import styled, { css } from 'styled-components';
import { ThemeProps } from '@/styles/global';

interface Pagination {
  disabledBack: boolean;
  disabledForward: boolean;
}

interface PageNumber {
  active: boolean;
}

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2.5rem;
  & a {
    &:first-child {
      ${(props: Pagination) =>
        props.disabledBack &&
        css`
          pointer-events: none;
          svg path {
            fill: ${(props: Pagination & ThemeProps) => props.theme.grayColor};
          }
        `}
      transform: rotate(180deg);
    }
    &:last-child {
      ${(props: Pagination) =>
        props.disabledForward &&
        css`
          pointer-events: none;
          svg path {
            fill: ${(props: Pagination & ThemeProps) => props.theme.grayColor};
          }
        `}
    }
    & svg {
      margin: 0.85rem 1.25rem;
      path {
        fill: ${(props: Pagination & ThemeProps) => props.theme.blackColor};
      }
    }
  }
`;

export const PageNumber = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  width: 2.5rem;
  height: 2.5rem;
  color: ${(props: ThemeProps) => props.theme.blackColor};
  font-weight: 500;
  ${(props: PageNumber & ThemeProps) =>
    props.active &&
    css`
      pointer-events: none;
      background-color: ${props.theme.softGreenColor};
      color: ${props.theme.whiteColor};
    `};
`;
